import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { InformationChip } from '@europrocurement/flexy-components';

export type DossierStatusProps = {
    label: string;
};

const DossierStatus: React.FunctionComponent<DossierStatusProps> = function (props) {
    const { label } = props;
    const { palette } = useTheme();
    let color: string = palette.primary.main;
    let bgColor: string = 'primary';

    switch (label) {
        case 'Validé':
            color = palette.success.main;
            bgColor = 'success';
            break;
        case 'Annulé':
            color = palette.grey['600'];
            bgColor = palette.grey['400'];
            break;
        case 'Dossier incomplet':
            color = palette.warning.main;
            bgColor = 'warning';
            break;
        default:
            color = palette.primary.main;
            bgColor = 'primary';
            break;
    }

    return (
        <InformationChip
            color={bgColor}
            label={
                <Typography
                    variant="l2dbodys"
                    color={color}
                >
                    {label}
                </Typography>
            }
        />
    );
};

export default DossierStatus;
